import React from 'react'
import { useTranslation } from 'react-i18next'
import Pagination from '../../../components/Pagination'
import { StudentItem } from './StudentItem/StudentItem'
import { useTeam } from '../Context/TeamContext'
import Config from '../../../config'
import { useQuery, useQueryClient } from 'react-query'
import { StudentDTO, updateUnAssigned } from '../../../apis/api.egg'
import Accordion from '../../../components/DesignSystem/components/molecules/Accordion/Accordion.component'
import Tooltip from '../../../components/DesignSystem/components/atoms/Tooltip/Tooltip.component'
import styles from './TeamAccordion.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
const { UNASSIGNED_BY_PAGE } = Config

export const UnassignedList = () => {
    const { courseID, unassignedPage } = useTeam()
    const queryClient = useQueryClient()
    const { t } = useTranslation('teamManager')

    /** Get unassigned list */
    const { data: unassigned } = useQuery(
        [courseID, 'Team', 'Unassigned', unassignedPage],
        () => updateUnAssigned(`${courseID}`, unassignedPage),
        {
            enabled: !!courseID,
            keepPreviousData: true,
        }
    )

    const preFetchUnassigned = () =>
        queryClient.prefetchQuery([courseID, 'Team', 'Unassigned', unassignedPage], () =>
            updateUnAssigned(`${courseID}`, unassignedPage)
        )

    return (
        <Accordion
            header={{
                icon: ['fas', 'users'],
                title: t('unassigned.title'),
                onMouseEnter: preFetchUnassigned,
                members: (
                    <Tooltip text={t('teamsList.numberOfMembers')} placement="topCenter">
                        <div className={styles.members}>
                            <FontAwesomeIcon icon="users" />
                            {unassigned ? (
                                <span className={styles.membersCount}>
                                    {unassigned.results.length}
                                </span>
                            ) : (
                                <span className={styles.membersCount}>0</span>
                            )}
                        </div>
                    </Tooltip>
                ),
            }}
        >
            {unassigned ? (
                <List unassigned={unassigned} />
            ) : (
                <div
                    className="empty-message"
                    style={{ textAlign: 'center', paddingBottom: '30px' }}
                >
                    <p>{t('empty.nothing-show')}</p>
                </div>
            )}
        </Accordion>
    )
}

const List = ({
    unassigned,
}: {
    unassigned: {
        results: StudentDTO[]
        pagination: {
            total: number
        }
    }
}) => {
    const { setPagination, team } = useTeam()

    const totalPages = unassigned ? Math.ceil(unassigned.pagination.total / UNASSIGNED_BY_PAGE) : 0
    return (
        <div className="container">
            <div>
                <div className="user-list">
                    {unassigned?.results.map((student) => (
                        <StudentItem
                            key={student._profileId}
                            {...student}
                            canDelete={true}
                            algorithmType={team?.algorithm?.algorithmType}
                        />
                    ))}
                </div>
            </div>

            {totalPages > 1 && (
                <div className="pagination-container" style={{ marginBottom: 0 }}>
                    <Pagination
                        onChange={(page) =>
                            setPagination((prev) => ({ ...prev, unassigned: page }))
                        }
                        count={totalPages}
                        boundary={1}
                        middles={5}
                    />
                </div>
            )}
        </div>
    )
}
